export type CatalogScope = 'included' | 'all';

type CatalogScopeSwitchProps = {
  id: string;
  includedLabel: string;
  allLabel: string;
  value: CatalogScope;
  onChange: (value: CatalogScope) => void;
};

export function CatalogScopeSwitch({
  id,
  includedLabel,
  allLabel,
  value,
  onChange,
}: CatalogScopeSwitchProps) {
  const options: { value: CatalogScope; label: string }[] = [
    { value: 'included', label: includedLabel },
    { value: 'all', label: allLabel },
  ];

  return (
    <div
      id={id}
      className="inline-flex items-stretch overflow-hidden rounded-full border border-[hsl(var(--ui-border))] bg-[hsl(var(--ui-fg))]"
      role="group"
      aria-label="Catalog scope"
    >
      {options.map((option, index) => (
        <button
          key={option.value}
          className={[
            'inline-flex cursor-pointer appearance-none items-center border-0 px-[calc(var(--size-md)-2px)] py-[var(--size-xs)] leading-none font-[var(--fw-display)] text-[var(--text-md)] transition-colors focus-visible:ring-2 focus-visible:ring-[hsl(var(--ui-borderHover))] focus-visible:outline-none',
            index > 0 ? 'border-l border-[hsl(var(--ui-border))]' : '',
            value === option.value
              ? 'bg-[hsl(var(--ui-control-bgActive))] text-[hsl(var(--ui-text-highContrast))] shadow-[inset_0_0_0_1px_hsl(var(--ui-borderHover))]'
              : 'bg-[hsl(var(--ui-fg))] text-[hsl(var(--ui-text-lowContrast))] hover:bg-[hsl(var(--ui-control-bgHover))]',
          ].join(' ')}
          type="button"
          onClick={() => onChange(option.value)}
          aria-pressed={value === option.value}
        >
          <span>{option.label}</span>
        </button>
      ))}
    </div>
  );
}
